// SEO
export const DEFAULT_PAGE_SEO_TITLE = "znaki.biz";
export const DEFAULT_PAGE_SEO_DESCRIPTION = "";
export const DEFAULT_NO_INDEX = false;
export const DEFAULT_NO_FOLLOW = false;
export const DEFAULT_OG_IMAGE: { src: string; alt: string } = {
  src: "",
  alt: "",
};

// NAVIGATION
export const HEADER_NAVIGATION_ID = "main";
export const FOOTER_NAVIGATION_ID = "footer";
export const SUBFOOTER_NAVIGATION_ID = "subfooter";

// FORMS
export const DEFAULT_FORM_SUBMIT_LABEL = "Отправить";
export const DEFAULT_FORM_FIELD_REQUIRED_ERROR = "Обязательное поле";
export const DEFAULT_FORM_SERVER_ERROR_MESSAGE =
  "К сожалению, что-то пошло не так. Мы уже исправляем проблему. Пожалуйста, попробуйте снова позже!";
